// extracted by mini-css-extract-plugin
export var avatarButton = "choose-profile-template-module--avatar-button--6RMQy";
export var avatarName = "choose-profile-template-module--avatar-name--VZ-1p";
export var chooseProfile = "choose-profile-template-module--choose-profile--hoGg+";
export var header = "choose-profile-template-module--header--QAw2V";
export var headerActions = "choose-profile-template-module--header-actions--jlZgZ";
export var itemMoveIn = "choose-profile-template-module--item-move-in--8o7n-";
export var profileItem = "choose-profile-template-module--profile-item--+oGtD";
export var profileList = "choose-profile-template-module--profile-list--iNOdk";
export var profilePickerWrapper = "choose-profile-template-module--profile-picker-wrapper--iHbui";